// extracted by mini-css-extract-plugin
export default {"LoadingDots":"LoadingDots-styles__LoadingDots__D3hNV","loading_dot":"LoadingDots-styles__loading_dot__q7IgI","hop":"LoadingDots-styles__hop__Wzuq5"};